var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.16496C11.1775 3.16496 10.3566 3.53136 9.72806 4.23841C9.09559 4.94994 8.72058 5.94145 8.72058 6.99996V9.83496H15.2795V6.99996C15.2795 5.94145 14.9045 4.94994 14.272 4.23841C13.6435 3.53136 12.8225 3.16496 12 3.16496ZM17.6095 9.83496V6.99996C17.6095 5.4063 17.048 3.85428 16.0135 2.69044C14.975 1.52213 13.535 0.834961 12 0.834961C10.4651 0.834961 9.02509 1.52213 7.98659 2.69044C6.95207 3.85428 6.39058 5.4063 6.39058 6.99996V9.83496H5.7778C4.02734 9.83496 2.83502 11.3848 2.83502 13V20C2.83502 21.6152 4.02734 23.165 5.7778 23.165H18.2222C19.9727 23.165 21.165 21.6152 21.165 20V13C21.165 11.3848 19.9727 9.83496 18.2222 9.83496H17.6095ZM5.7778 12.165C5.56458 12.165 5.16502 12.406 5.16502 13V20C5.16502 20.5939 5.56458 20.835 5.7778 20.835H18.2222C18.4355 20.835 18.835 20.5939 18.835 20V13C18.835 12.406 18.4355 12.165 18.2222 12.165H5.7778Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.25f80ef170e28e3f776c255325ee12a3.svg";
export { ForwardRef as ReactComponent };